module.exports = __webpack_public_path__ + "img/6.c6f02704.png";